import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { FileService } from 'src/app/services/file.service';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';
import { DueDatesComponent } from './subscription-components/due-dates/due-dates.component';
import { FormComponentComponent } from 'src/app/components/form-component/form-component.component';
import { SubscriptionUserComponent } from '../../componentsAdmin/subscription-user/subscription-user.component';

@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscriptions.page.html',
  styleUrls: ['./subscriptions.page.scss'],
})
export class SubscriptionsPage implements OnInit, OnDestroy {
  @ViewChild('subscriptionUser') subscriptionUser: SubscriptionUserComponent;
  @ViewChild('duesDates') duesDates: DueDatesComponent;
  @ViewChild('formComponent') formComponent: FormComponentComponent;
  public subscriptionId = undefined;
  public value = 'subscription';
  public savedForm = undefined;
  public buttons = [
    {
      value: 'subscription',
      name: 'Suscripciones',
    },
    {
      value: 'user',
      name: 'Pagos',
    },
  ];
  public edit = [];
  public id = undefined;
  public fieldForms: any[] = undefined;
  public isUploading = false;
  public subscriptionTitle = '';
  private _domainId = environment.domainId;
  private _subscription: Subscription = new Subscription();

  constructor(
    private fileSv: FileService,
    private uiSv: UiServices,
    private formSv: FormServices,
    private httpSv: HttpService,
    private trSv: TranslateService,
    private paramSv: ParamServicesService
  ) {}

  ngOnInit() {
    this.getForm(false);
  }

  async getForm(replaceParentSelect) {
    try {
      const res = await this.formSv.getForm('subscription', this._domainId);
      if (!replaceParentSelect) {
        this.fieldForms = res;
      } else {
        const fieldId = res.findIndex((x) => x.fieldName === 'parentId');
        this.fieldForms[fieldId] = res[fieldId];
      }

      this.manageViewTitle();

      this._subscription.add(
        this.paramSv.emitImagesObs.subscribe((item: any) => {
          if (item === 'finish') {
            this.manageViewTitle();
          }
        })
      );
    } catch (err) {
      console.error(err);
    }
  }

  getList() {
    this.subscriptionUser.reset();
  }

  manageViewTitle() {
    if (this.paramSv.modulesNames.length) {
      const existModule = this.paramSv.modulesNames.find(
        (x) => x.name === 'Suscripciones'
      );
      if (existModule) {
        this.buttons.find((x) => x.name === existModule.name).name =
          existModule.newName;
        this.subscriptionTitle = existModule.newName;
      }
    } else this.subscriptionTitle = 'Suscripciones';
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  changedDuesQuantity(quantityDues) {
    quantityDues > 0
      ? this.formComponent.dinamicForm.get('frequency').disable()
      : this.formComponent.dinamicForm.get('frequency').enable();
  }

  async sendInfo(ev: FormData) {
    try {
      this.duesDates.testQuestions.forEach((item, index) => {
        item.dues = index + 1;
      });
      ev.set('dueDates', JSON.stringify(this.duesDates.testQuestions));
      this.id && ev.set('id', String(this.id));
      this.isUploading = true;
      const res: any = await this.httpSv.itemAction(
        ev,
        'subscription',
        this.id ? 'update' : 'store'
      );
      this.isUploading = false;
      const tr = this.trSv.instant('Guardado exitosamente');
      await this.uiSv.showToast(tr);
      if (res.status) {
        this.duesDates.testQuestions = [];
        this.id = undefined;
        this.formSv.clearFormSrc.next();
        this.formSv.deleteListProductSrc.next('reloadListProduct');
      }
    } catch (err) {
      console.error(err);
    }
  }

  async getSubscriptions({ product, action, changeAction }) {
    try {
      await this.getForm(true);
      const { id, savedForm } = await this.fileSv.getProduct(
        { product, action, changeAction },
        this.id,
        'subscription',
        'Subscripción',
        this.savedForm
      );
      this.id = id;
      this.savedForm = savedForm;
      this.duesDates.testQuestions = savedForm.duesDates;
      this.changedDuesQuantity(this.duesDates.testQuestions.length);
      this.edit = this.savedForm.media;
      const fieldId = this.fieldForms.findIndex(
        (x) => x.fieldName === 'parentId'
      );
      const fieldForm = this.fieldForms[fieldId];
      if (action === 'edit') {
        fieldForm.select = fieldForm.select.filter(
          (x) => x.name !== this.savedForm.name
        );
      }
    } catch (err) {
      await this.uiSv.loading?.dismiss();
    }
  }
}
